module.exports = __webpack_public_path__ + "static/media/get_more_right_arrow.ed9ac32b.svg";